/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AssetHardwareType {
    Netradyne = 0,
    Omnitracs = 1,
    MichiganLicensePlate = 2,
    BestPass = 3,
    FuelCard = 4,
    BridgeTag = 5,
    LeadCard = 6,
    Transponder = 7,
    DecalsDoorsOnly = 8,
    NameBadge = 9,
    TriStateSamsara = 10,
    LoadOneSamsara = 11,
    DecalsFullWrap = 12,
    IFTANYHUTSticker = 13,
    PermitBinder = 14,
    SamsaraCamera = 15,
    SamsaraGatewayCord = 16,
}
